import {
    PROJECTS_CRUD_SET_CURRENT_SUB_PROJECT,
    MULTIBED_RESET_APP_STATE,
} from "../lib/types";

export const setCurrentSubProject = project => dispatch => {
    dispatch({
        type: PROJECTS_CRUD_SET_CURRENT_SUB_PROJECT,
        payload: project
    });
};

export const clearViewPort = () => dispatch => {
    dispatch({
        type: MULTIBED_RESET_APP_STATE,
    });
}



// WEBPACK FOOTER //
// ./src/actions/sub-project-actions.js